import React, { createContext, useContext, useMemo, useState } from 'react'
import { getInfosOpcionais, postVendaOpcionais, postConviteEmailMGM } from '../api/opcionais.servico'
import { useGlobal } from '../contexts/GlobalContext'
import { isArray, isEmptyObject } from '../utils/helpers/helpers'
import { EVENTOS_PIXEL } from '../containers/Opcionais/constantsCardOpcionais'
import { getAssinaturaDoAssociadoPorModalidade, getModalidadeDeAssinatura } from '../utils/helpers/helpersAssinatura'
import ReactPixel from 'react-facebook-pixel'

const OpcionaisContext = createContext()

function OpcionaisProvider( props ) {
  const [ state, setState ] = useState( {
    'dadosOpcionais': {},
    'enviadoEmailMGM': false,
    'enviandoEmailMGM': false,
    'finalizarCompraOpcionais': false,
    'infoPagamento': null,
    'loadingOpcionais': false,
    'loadingRequisicaoCompraOpcionais': false,
    'mesOpcional': null,
    'modalidadesEscolhidaOpcionais': [],
    'opcionaisSelecionados': [],
    'respostaCompraOpcionais': {}
  } )

  const value = useMemo( () => {
    return {
      setState,
      state
    }
  }, [ state ] )

  return (
    <OpcionaisContext.Provider
      value={ value }
      { ...props }
    />
  )
}

function useOpcionais() {
  const context = useContext( OpcionaisContext )
  if ( !context ) {
    throw new Error( 'useOpcionais deve ser usado dentro de um OpcionaisProvider' )
  }

  const { state, setState } = context
  const { dadosGlobaisAssociado, setErroRequisicao } = useGlobal()

  const setDadosOpcionais = dadosOpcionais => {
    setState( prevState => ( {
      ...prevState,
      dadosOpcionais
    } ) )
  }

  const setInfoPagamento = infoPagamento => {
    setState( prevState => ( {
      ...prevState,
      infoPagamento
    } ) )
  }

  const setOpcionalSelecionado = opcionaisSelecionados => {
    setState( prevState => ( {
      ...prevState,
      opcionaisSelecionados
    } ) )
  }

  const setLoadingOpcionais = loadingOpcionais => {
    setState( prevState => ( {
      ...prevState,
      loadingOpcionais
    } ) )
  }

  const setModalidadesEscolhidaOpcionais = modalidadesEscolhidaOpcionais => {
    setState( prevState => ( {
      ...prevState,
      modalidadesEscolhidaOpcionais
    } ) )
  }

  const setFinalizarCompraOpcionais = finalizarCompraOpcionais => {
    setState( prevState => ( {
      ...prevState,
      finalizarCompraOpcionais
    } ) )
  }

  const setEnviandoEmailMGM = enviandoEmailMGM => {
    setState( prevState => ( {
      ...prevState,
      enviandoEmailMGM
    } ) )
  }

  const setEnviadoEmailMGM = enviadoEmailMGM => {
    setState( prevState => ( {
      ...prevState,
      enviadoEmailMGM
    } ) )
  }

  const setRespostaCompraOpcionais = respostaCompraOpcionais => {
    setState( prevState => ( {
      ...prevState,
      respostaCompraOpcionais
    } ) )
  }

  const setMesOpcional = mesOpcional => {
    setState( prevState => ( {
      ...prevState,
      mesOpcional
    } ) )
  }

  const setLoadingRequisicaoCompraOpcionais = loadingRequisicaoCompraOpcionais => {
    setState( prevState => ( {
      ...prevState,
      loadingRequisicaoCompraOpcionais
    } ) )
  }

  const limparStateOpcionais = () => {
    setState( prevState => ( {
      ...prevState,
      'finalizarCompraOpcionais': false,
      'respostaCompraOpcionais': {}
    } ) )
  }

  const fetchDadosOpcionais = async() => {
    try {
      setLoadingOpcionais( true )
      const { 'data': dados } = await getInfosOpcionais()
      if ( !isEmptyObject( dados ) ) {
        setDadosOpcionais( dados )
      }
    } catch ( erro ) {
      setErroRequisicao( erro.response.status )
    } finally {
      setLoadingOpcionais( false )
    }
  }

  // eslint-disable-next-line no-unused-vars
  const comprarOpcional = async( modalidadeEscolhida ) => {
    setLoadingRequisicaoCompraOpcionais( true )
    let idsAssinaturas = []
    if ( isArray( modalidadeEscolhida ) && modalidadeEscolhida.length ) {
      idsAssinaturas = modalidadeEscolhida.reduce( ( acc, modalidade ) => {
        const modalidadeAssinatura = getAssinaturaDoAssociadoPorModalidade( dadosGlobaisAssociado.assinaturas, modalidade ).id
        return [ ...acc, modalidadeAssinatura ]
      }, [] )
    } else {
      idsAssinaturas = [ ...getAssinaturaDoAssociadoPorModalidade( dadosGlobaisAssociado.assinaturas, modalidadeEscolhida ).id ]
    }

    const idsProdutos = state.opcionaisSelecionados.map( opcional => opcional.id )

    try {
      const { 'data': dados } = await postVendaOpcionais( {
        ...state.infoPagamento,
        'ids_assinaturas': idsAssinaturas,
        'ids_produtos': idsProdutos
      } )

      if ( dados && dados.length ) {
        let respostaCompra = []
        // eslint-disable-next-line array-callback-return
        dados.map( dado => {
          const [ info ] = Object.entries( dado )
          const [ idAssinaturaDado, infoDadoRequisicao ] = info
          const assinaturaOpcional = dadosGlobaisAssociado.assinaturas.find( assinatura => assinatura.id === Number( idAssinaturaDado ) )
          const [ modalidadeAssinaturaOpcional ] = getModalidadeDeAssinatura( [ assinaturaOpcional ] )
          respostaCompra = [
            ...respostaCompra,
            {
              ...infoDadoRequisicao,
              'idAssinatura': Number( idAssinaturaDado ),
              'modalidade': modalidadeAssinaturaOpcional
            }
          ]
        } )

        const comprouComSucesso = respostaCompra.reduce( ( temSucesso, item ) => {
          return temSucesso || !item.erro
        }, false )

        if ( comprouComSucesso ) {
          ReactPixel.trackCustom( EVENTOS_PIXEL.FINALIZOU_OPCIONAL )
        }

        if ( respostaCompra.length ) {
          setRespostaCompraOpcionais( respostaCompra )
        }

        fetchDadosOpcionais()
      }
      setFinalizarCompraOpcionais( true )
    } catch ( erro ) {
      setFinalizarCompraOpcionais( true )
      setErroRequisicao( erro?.response?.status )
    } finally {
      setModalidadesEscolhidaOpcionais( [] )
      setInfoPagamento( {} )
      setLoadingRequisicaoCompraOpcionais( false )
    }
  }

  const enviarEmailMGM = async( email ) => {
    setEnviandoEmailMGM( true )
    setEnviadoEmailMGM( false )
    try {
      await postConviteEmailMGM( email )
      setEnviadoEmailMGM( true )
    } catch ( erro ) {
      setErroRequisicao( erro.response.status )
      setEnviadoEmailMGM( false )
    } finally {
      setEnviandoEmailMGM( false )
    }
  }


  return {
    comprarOpcional,
    'dadosOpcionais': state.dadosOpcionais,
    'enviadoEmailMGM': state.enviadoEmailMGM,
    'enviandoEmailMGM': state.enviandoEmailMGM,
    enviarEmailMGM,
    fetchDadosOpcionais,
    'finalizarCompraOpcionais': state.finalizarCompraOpcionais,
    'infoPagamento': state.infoPagamento,
    limparStateOpcionais,
    'loadingOpcionais': state.loadingOpcionais,
    'loadingRequisicaoCompraOpcionais': state.loadingRequisicaoCompraOpcionais,
    'mesOpcional': state.mesOpcional,
    'modalidadesEscolhidaOpcionais': state.modalidadesEscolhidaOpcionais,
    'opcionaisSelecionados': state.opcionaisSelecionados,
    'respostaCompraOpcionais': state.respostaCompraOpcionais,
    setEnviadoEmailMGM,
    setInfoPagamento,
    setMesOpcional,
    setModalidadesEscolhidaOpcionais,
    setOpcionalSelecionado
  }
}

export { OpcionaisProvider, useOpcionais }
